import React from 'react';
import { OptionsAssetIcon } from './OptionsAssetIcon';
import { formatStrategyLabel } from './optionsHistoryUtils';

export const OptionsUnderlyingStrategyTitle = ({
  underlying,
  strategy,
  prefix = null,
  suffixNode = null,
  as: Component = 'div',
  className = '',
  iconSize = 18,
  formatStrategy = true,
  testId,
}) => {
  const strategyText = formatStrategy ? formatStrategyLabel(strategy) : strategy;

  return (
    <Component className={`inline-flex flex-wrap items-center gap-2 ${className}`.trim()} data-testid={testId}>
      {prefix ? <span className="text-white/72">{prefix}</span> : null}
      <span className="inline-flex items-center gap-2 align-middle">
        <OptionsAssetIcon assetKey={underlying} size={iconSize} className="shrink-0" />
        <span>{strategyText}</span>
      </span>
      {suffixNode}
    </Component>
  );
};

export default OptionsUnderlyingStrategyTitle;